const nav = [{
    "id": 10,
    "label": "商店",
    "icon": "icon-remen",
    "select": false,
    "path": "smShop",
    "data": [{
      "id": 1001,
      "label": "商店",
      "children": [{
        "id": 100101,
        "label": "线上商店",
        "path": "smShop",
        "select": false,
        "navTitle": "商店/线上商店"
      }]
    }, ]
  }, {
    "id": 11,
    "label": "概况",
    "icon": "icon-gaikuang1",
    "select": false,
    "path": "mydesktop",
    "data": [{
        "id": 1102,
        "label": "桌面",
        "children": [{
          "id": 110201,
          "label": "我的桌面",
          "path": "mydesktop",
          "select": false,
          "navTitle": "桌面/我的桌面"
        }]
      },
      {
        "id": 1101,
        "label": "报表",
        "children": [{
            "id": 110101,
            "label": "营业概况",
            "path": "survey",
            "select": false,
            "navTitle": "报表/营业概况"
          },

          {
            "id": 110103,
            "label": "交易排行",
            "path": "transactionranking",
            "select": false,
            "navTitle": "报表/交易排行"
          }
        ]
      }
    ]
  },
  {
    "id": 12,
    "label": "基础",
    "icon": "icon-jichu",
    "select": false,
    "path": "jcDh",
    "data": [{
        "id": 1200,
        "label": "导航",
        "select": false,
        "children": [{
          "id": 120001,
          "label": "基础导航",
          "select": false,
          "path": "jcDh",
          "navTitle": "基础/基础导航"
        }]
      },
      {
        "id": 1201,
        "label": "基础",
        "select": false,
        "children": [{
            "id": 120101,
            "label": "供应商档",
            "select": false,
            "path": "supplier",
            "navTitle": "基础/供应商档"
          }, {
            "id": 120102,
            "label": "商品档案",
            "select": false,
            "path": "commodity",
            "navTitle": "基础/商品档案"
          }, {
            "id": 120117,
            "label": "商品属性",
            "select": false,
            "navTitle": "基础/商品属性",
            "path": "proAttribute"
          }, {
            "id": 120118,
            "label": "打印方案",
            "select": false,
            "navTitle": "基础/打印方案",
            "path": "proPrinter"
          }, {
            "id": 120103,
            "label": "商品组合",
            "select": false,
            "navTitle": "基础/商品组合",
            "path": "assortedGoods"
          }, {
            "id": 120104,
            "label": "单位信息",
            "select": false,
            "path": "unitinformation",
            "navTitle": "基础/单位信息"
          }, {
            "id": 120105,
            "label": "品牌信息",
            "select": false,
            "navTitle": "基础/品牌信息",
            "path": "brandInfo"
          },
          // {
          //   "id": 120106,
          //   "label": "标签打印",
          //   "select": false,
          //   "path": "labelprinting",
          //   "navTitle": "基础/标签打印"
          // }, {
          //   "id": 120107,
          //   "label": "散装传秤",
          //   "select": false,
          //   "path": "bulkweighing",
          //   "navTitle": "基础/散装传秤"
          // },
          {
            "id": 120108,
            "label": "资金账户",
            "select": false,
            "path": "capitalaccount",
            "navTitle": "基础/资金账户"
          }, {
            "id": 120109,
            "label": "费用项目",
            "select": false,
            "path": "expenseitem",
            "navTitle": "基础/费用项目"
          }, {
            "id": 120110,
            "label": "员工档案",
            "path": "employees",
            "select": false,
            "navTitle": "基础/员工档案"
          },
          {
            "id": 120111,
            "label": "员工权限",
            "path": "employeeauthority",
            "select": false,
            "navTitle": "基础/员工权限"
          }, {
            "id": 120112,
            "label": "门店档案",
            "select": false,
            "path": "store",
            "navTitle": "基础/门店档案"
          },
          {
            "id": 120113,
            "label": "价格调整",
            "select": false,
            "path": "editPriceBill",
            "navTitle": "基础/价格调整"
          },
          {
            "id": 120114,
            "label": "调价记录",
            "select": false,
            "path": "editPriceRecord",
            "navTitle": "基础/调价记录"
          },
          {
            "id": 120115,
            "label": "商品序号",
            "select": false,
            "path": "serialnumber",
            "navTitle": "基础/商品序号"
          },
          {
            "id": 120116,
            "label": "保质期限",
            "select": false,
            "path": "qualityguaranteeperiod",
            "navTitle": "基础/保质期限"
          },
          {
            "id": 120119,
            "label": "电子价签",
            "path": "elabelAdmin",
            "navTitle": "价签/电子价签"
          }, {
            "id": 120120,
            "label": "价签商品",
            "path": "elabelProAdmin",
            "navTitle": "价签/价签商品"
          },
        ]
      }
    ]
  },
  {
    "id": 13,
    "label": "采购",
    "icon": "icon-caigou",
    "path": "cgDh",
    "select": false,
    "data": [{
        "id": 1300,
        "label": "导航",
        "seats": false,
        "children": [{
          "id": 130001,
          "label": "采购导航",
          "path": "cgDh",
          "navTitle": "采购/采购导航"
        }]
      },
      {
        "id": 1301,
        "label": "采购",
        "seats": false,
        "children": [{
            "id": 130101,
            "label": "采购进货",
            "path": "purchaseandpurchase",
            "navTitle": "采购/采购进货"
          },
          {
            "id": 130102,
            "label": "采购退货",
            "path": "purchasereturn",
            "navTitle": "采购/采购退货"
          },
          {
            "id": 130103,
            "label": "一品多商",
            "path": "oneProMoreGys",
            "navTitle": "采购/一品多商"
          }
        ]
      },
      {
        "id": 1302,
        "label": "报表",
        "seats": false,
        "children": [{
            "id": 130201,
            "label": "采购单据",
            "path": "documentdetailscgdj",
            "navTitle": "报表/采购单据"
          },
          {
            "id": 130202,
            "label": "采购商品",
            "path": "commoditydetails",
            "navTitle": "报表/采购商品"
          },
          {
            "id": 130203,
            "label": "采购汇总",
            "path": "commoditysummary",
            "navTitle": "报表/采购汇总"
          }
        ]
      },
      {
        "id": 1303,
        "label": "结算",
        "seats": false,
        "children": [{
          "id": 130301,
          "label": "采购账款",
          "path": "accountsummary",
          "navTitle": "结算/采购账款"
        }, {
          "id": 130302,
          "label": "采账明细",
          "path": "accountdetails",
          "navTitle": "结算/采账明细"
        }]
      }
    ]
  },
  {
    "id": 14,
    "label": "零售",
    "icon": "icon-lingshou",
    "select": false,
    "path": "lsDh",
    "data": [{
        "id": 1400,
        "label": "导航",
        "seats": false,
        "children": [{
          "id": 140001,
          "label": "零售导航",
          "path": "lsDh",
          "navTitle": "报表/零售导航"
        }]
      },
      {
        "id": 1401,
        "label": "报表",
        "seats": false,
        "children": [{
            "id": 140107,
            "label": "经营概况",
            "path": "businessoverview",
            "navTitle": "报表/经营概况"
          },
          {
            "id": 140101,
            "label": "交班对账",
            "path": "employeeHandover",
            "navTitle": "报表/交班对账"
          },

          {
            "id": 140106,
            "label": "门店收款",
            "path": "storecollection",
            "navTitle": "报表/门店收款"
          },

          // {
          //   "id": 140102,
          //   "label": "收款明细",
          //   "path": "documentdetailsone",
          //   "navTitle": "报表/收款明细"
          // },
          {
            "id": 140103,
            "label": "单据明细",
            "path": "retaildetails",
            "navTitle": "报表/单据明细"
          },
          {
            "id": 140104,
            "label": "商品明细",
            "path": "documentdetailsa",
            "navTitle": "报表/商品明细"
          },
          {
            "id": 140105,
            "label": "商品汇总",
            "path": "productsummary",
            "navTitle": "报表/商品汇总"
          },
          {
            "id": 140108,
            "label": "外卖订单",
            "path": "takeWayOrder",
            "navTitle": "报表/外卖订单"
          },
          {
            "id": 140109,
            "label": "外卖商品",
            "path": "takeWayDetail",
            "navTitle": "报表/外卖商品"
          }
        ]
      },

      {
        "id": 1402,
        "label": "促销",
        "seats": false,
        "children": [{
            "id": 140209,
            "label": "促销导航",
            "path": "promotionnavigation",
            "navTitle": "促销/促销导航"
          }, {
            "id": 140202,
            "label": "折扣促销",
            "path": "fullcourtdiscount",
            "navTitle": "促销/折扣促销"
          },
          {
            "id": 140203,
            "label": "满减促销",
            "path": "fullfieldfullreduction",
            "navTitle": "促销/满减促销"
          },
          {
            "id": 140204,
            "label": "满折促销",
            "path": "fulldiscountpromotion",
            "navTitle": "促销/满折促销"
          },
          {
            "id": 140205,
            "label": "限时特价",
            "path": "limitedtimespecialprice",
            "navTitle": "促销/限时特价"
          },
          {
            "id": 140206,
            "label": "套餐促销",
            "path": "fixedpackage",
            "navTitle": "促销/套餐促销"
          },
          {
            "id": 140207,
            "label": "满赠促销",
            "path": "freepromotion",
            "navTitle": "促销/满赠促销"
          },
          {
            "id": 140208,
            "label": "组合促销",
            "path": "combinedpromotion",
            "navTitle": "促销/组合促销"
          },
          {
            "id": 140210,
            "label": "卡券促销",
            "path": "cardcouponpromotion",
            "navTitle": "促销/卡券促销"
          },
          {
            "id": 140201,
            "label": "促销汇总",
            "path": "promotionsummary",
            "navTitle": "促销/促销汇总"
          }
        ]
      }, {
        "id": 1403,
        "label": "设置",
        "seats": false,
        "children": [{
          "id": 140301,
          "label": "副屏广告",
          "path": "fpGg",
          "navTitle": "设置/副屏广告"
        }]
      },
    ]
  },
  {
    "id": 15,
    "label": "会员",
    "icon": "icon-huiyuan",
    "seats": false,
    "path": "hyDh",
    "data": [{
        "id": 1500,
        "label": "导航",
        "seats": false,
        "children": [{
          "id": 150001,
          "label": "会员导航",
          "path": "hyDh",
          "navTitle": "操作/会员导航"
        }]
      },
      {
        "id": 1501,
        "label": "操作",
        "seats": false,
        "children": [{
            "id": 150101,
            "label": "会员档案",
            "path": "memberpro",
            "navTitle": "操作/会员档案"
          },
          {
            "id": 150109,
            "label": "电子会员",
            "path": "eCard",
            "navTitle": "操作/电子会员"
          }, {
            "id": 150103,
            "label": "充值方案",
            "path": "rechargeScheme",
            "navTitle": "操作/充值方案"
          }, {
            "id": 150104,
            "label": "兑换商品",
            "path": "pointExchange",
            "navTitle": "操作/兑换商品"
          }, {
            "id": 150105,
            "label": "短信通知",
            "path": "smsSet",
            "navTitle": "操作/短信通知"
          }, {
            "id": 150106,
            "label": "微信通知",
            "path": "wxSet",
            "navTitle": "操作/微信通知"
          },

          {
            "id": 150107,
            "label": "卡券管理",
            "path": "cardandcouponmanagement",
            "navTitle": "操作/卡券管理"
          }, {
            "id": 150108,
            "label": "次卡项目",
            "path": "onceCard",
            "navTitle": "操作/次卡项目"
          }, {
            "id": 150110,
            "label": "礼包管理",
            "path": "giftBagManage",
            "navTitle": "操作/礼包管理"
          }
        ]
      }, {
        "id": 1502,
        "label": "报表",
        "seats": false,
        "children": [{
          "id": 150201,
          "label": "会员余额",
          "path": "memberbalance",
          "navTitle": "报表/会员余额"
        }, {
          "id": 150202,
          "label": "会员积分",
          "path": "membershippoints",
          "navTitle": "报表/会员积分"
        }, {
          "id": 150203,
          "label": "兑换明细",
          "path": "exchangedetails",
          "navTitle": "报表/兑换明细"
        }, {
          "id": 150204,
          "label": "消费排行",
          "path": "consumptionranking",
          "navTitle": "报表/消费排行"
        }, {
          "id": 150205,
          "label": "商品排行",
          "path": "productranking",
          "navTitle": "报表/商品排行"
        },  {
          "id": 150209,
          "label": "分享详情",
          "path": "fxYlBill",
          "navTitle": "报表/分享详情"
        },{
          "id": 150210,
          "label": "付费会员",
          "path": "ffHyBill",
          "navTitle": "报表/付费会员"
        },  {
          "id": 150211,
          "label": "升降明细",
          "path": "hyDjBill",
          "navTitle": "报表/升降明细"
        }, {
          "id": 150207,
          "label": "次卡明细",
          "path": "subcarddetails",
          "navTitle": "报表/次卡明细"
        }, {
          "id": 150208,
          "label": "商品寄存",
          "path": "merchandisedeposit",
          "navTitle": "报表/商品寄存"
        }]
      }
    ]
  },

  {
    "id": 17,
    "label": "批发",
    "icon": "icon-pifa",
    "select": false,
    "path": "pfDh",
    "data": [{
        "id": 1700,
        "label": "导航",
        "seats": false,
        "children": [{
          "id": 170001,
          "label": "批发导航",
          "path": "pfDh",
          "navTitle": "批发/批发导航"
        }]
      },
      {
        "id": 1701,
        "label": "批发",
        "seats": false,
        "children": [{
            "id": 170101,
            "label": "客户档案",
            "path": "customerprofile",
            "navTitle": "批发/客户档案"
          },
          {
            "id": 170102,
            "label": "批发销售",
            "path": "wholesalesales",
            "navTitle": "批发/批发销售"
          },
          {
            "id": 170103,
            "label": "批发退货",
            "path": "wholesalereturn",
            "navTitle": "批发/批发退货"
          },
          {
            "id": 170104,
            "label": "一品多客",
            "path": "oneProMoreKh",
            "navTitle": "批发/一品多客"
          }
        ]
      }, {
        "id": 1702,
        "label": "报表",
        "seats": false,
        "children": [{
            "id": 170201,
            "label": "批发单据",
            "path": "wholesaledocumentdetails",
            "navTitle": "报表/批发单据"
          },
          {
            "id": 170202,
            "label": "批发商品",
            "path": "wholesalecommoditydetails",
            "navTitle": "报表/批发商品"
          },
          {
            "id": 170203,
            "label": "批发汇总",
            "path": "commoditywholesalesummary",
            "navTitle": "报表/批发汇总"
          }
        ]
      }, {
        "id": 1703,
        "label": "结算",
        "seats": false,
        "children": [{
            "id": 170301,
            "label": "批发账款",
            "path": "customeraccountssummary",
            "navTitle": "结算/批发账款"
          },
          {
            "id": 170302,
            "label": "批账明细",
            "path": "customeraccountdetails",
            "navTitle": "结算/批账明细"
          }
        ]
      }
    ]
  },
  {
    "id": 18,
    "label": "推广",
    "icon": "icon-yingxiao",
    "select": false,
    "path": "masssmssending",
    "data": [{
      "id": 1803,
      "label": "短信",
      "seats": false,
      "children": [{
          "id": 180301,
          "label": "短信群发",
          "path": "masssmssending",
          "navTitle": "短信/短信群发"
        },
        {
          "id": 180302,
          "label": "短信明细",
          "path": "senddetails",
          "navTitle": "短信/短信明细"
        }
      ]
    }]
  },
  {
    "id": 19,
    "label": "仓库",
    "icon": "icon-cangku",
    "path": "ckDh",
    "select": false,
    "data": [{
        "id": 1900,
        "label": "导航",
        "seats": false,
        "children": [{
          "id": 190001,
          "label": "仓库导航",
          "path": "ckDh",
          "navTitle": "报表/仓库导航"
        }]
      },
      {
        "id": 1903,
        "label": "库存",
        "seats": false,
        "children": [{
            "id": 190301,
            "label": "实时库存",
            "path": "realtimeinventory",
            "navTitle": "报表/实时库存"
          },
          {
            "id": 190302,
            "label": "库存明细",
            "path": "lnventorydetails",
            "navTitle": "报表/库存明细"
          },
          {
            "id": 190303,
            "label": "门店商品",
            "path": "wproductsummarycksp",
            "navTitle": "报表/门店商品"
          },


        ]
      },
      {
        "id": 1902,
        "label": "调库",
        "seats": false,
        "children": [{
            "id": 190201,
            "label": "商品报损",
            "path": "commoditylossreporting",
            "navTitle": "盘点/商品报损"
          },
          {
            "id": 190305,
            "label": "报损单据",
            "path": "lossdocument",
            "navTitle": "报表/报损单据"
          },
          {
            "id": 190202,
            "label": "库存盘点",
            "path": "lnventorycount",
            "navTitle": "盘点/库存盘点"
          },
          {
            "id": 190304,
            "label": "盘点单据",
            "path": "lnventorysummary",
            "navTitle": "报表/盘点单据"
          },
        ]
      },
      {
        "id": 1904,
        "label": "联营",
        "seats": false,
        "children": [{
            "id": 190401,
            "label": "调货设置",
            "path": "transfersettings",
            "navTitle": "连锁/调货设置"
          }, {
            "id": 190101,
            "label": "门店调货",
            "path": "storetransfer",
            "navTitle": "调拨/门店调货"
          },
          {
            "id": 190403,
            "label": "调拨单据",
            "path": "transferDocument",
            "navTitle": "报表/调拨单据"
          }, {
            "id": 190404,
            "label": "调货明细",
            "path": "transferDocumentDetail",
            "navTitle": "报表/调货明细"
          },
          {
            "id": 190103,
            "label": "门店账款",
            "path": "storeaccounts",
            "navTitle": "调拨/门店账款"
          }, {
            "id": 190104,
            "label": "账款明细",
            "path": "accountdetailsone",
            "navTitle": "调拨/账款明细"
          },

          {
            "id": 190402,
            "label": "商品管理",
            "path": "storemerchandise",
            "navTitle": "连锁/商品管理"
          }
        ]
      }
    ]
  },
  {
    "id": 22,
    "label": "加盟",
    "icon": "icon-jiameng",
    "select": false,
    "path": "jmmd",
    "data": [{
        "id": 2201,
        "label": "加盟我的",
        "seats": false,
        "children": [{
            "id": 220101,
            "label": "加盟门店",
            "navTitle": "加盟我的/加盟门店",
            "path": "jmmd"
          }, {
            "id": 220102,
            "label": "加盟品库",
            "navTitle": "加盟我的/加盟品库",
            "path": "jmsp"
          }, {
            "id": 220103,
            "label": "门店销售",
            "navTitle": "加盟我的/门店销售",
            "path": "jmwdMdxs"
          }, {
            "id": 220104,
            "label": "销售汇总",
            "navTitle": "加盟我的/销售汇总",
            "path": "jmwdXshz"
          }, {
            "id": 220105,
            "label": "门店排行",
            "navTitle": "加盟我的/门店排行",
            "path": "jmwdMdph"
          }, {
            "id": 220106,
            "label": "商户汇总",
            "navTitle": "加盟我的/商户汇总",
            "path": "jmwdShhz"
          },
          {
            "id": 220108,
            "label": "要货订单",
            "navTitle": "加盟我的/要货订单",
            "path": "yhdd"
          },
          {
            "id": 220110,
            "label": "加盟直调",
            "navTitle": "加盟我的/加盟直调",
            "path": "jmzd"
          },
          {
            "id": 220111,
            "label": "直调订单",
            "navTitle": "加盟我的/直调订单",
            "path": "zddd"
          },
          {
            "id": 220109,
            "label": "加盟账款",
            "navTitle": "加盟我的/加盟账款",
            "path": "jmzk"
          },
          // {
          //   "id": 220103,
          //   "label": "线上商品",
          //   "navTitle": "加盟我的/线上商品",
          //   "path": "onlinegoods"
          // },
        ]
      },
      {
        "id": 2202,
        "label": "我的加盟",
        "seats": false,
        "children": [{
          "id": 220201,
          "label": "总部门店",
          "navTitle": "我的加盟/总部门店",
          "path": "zbmd"
        }, {
          "id": 220204,
          "label": "加盟订货",
          "navTitle": "我的加盟/加盟订货",
          "path": "jmdh"
        }, {
          "id": 220205,
          "label": "订货订单",
          "navTitle": "我的加盟/订货订单",
          "path": "dhdd"
        }, {
          "id": 220202,
          "label": "销售汇总",
          "navTitle": "我的加盟/销售汇总",
          "path": "wdjmXshz"
        }, {
          "id": 220203,
          "label": "门店排行",
          "navTitle": "我的加盟/门店排行",
          "path": "wdjmMdph"
        }, ]
      },

    ]


  },
  {
    "id": 20,
    "label": "财务",
    "icon": "icon-caiwu",
    "path": "cwDh",
    "select": false,
    "data": [{
        "id": 2000,
        "label": "导航",
        "seats": false,
        "children": [{
          "id": 200001,
          "label": "财务导航",
          "path": "cwDh",
          "navTitle": "报表/财务导航"
        }]
      },
      {
        "id": 2001,
        "label": "报表",
        "seats": false,
        "children": [{
            "id": 200101,
            "label": "月结报表",
            // monthlystatement
            "path": "yjHz",
            "navTitle": "报表/月结报表"
          },
          // {
          //   "id": 200108,
          //   "label": "月结汇总",
          //   "path": "yjHz",
          //   "navTitle": "报表/月结汇总"
          // },
          {
            "id": 200102,
            "label": "资金汇总",
            "path": "financefundsummary",
            "navTitle": "报表/资金汇总"
          },
          {
            "id": 200103,
            "label": "资金明细",
            "path": "financefunddetails",
            "navTitle": "报表/资金明细"
          },
          {
            "id": 200104,
            "label": "员工提成",
            "path": "financeemployeecommission",
            "navTitle": "报表/员工提成"
          },
          {
            "id": 200105,
            "label": "提成明细",
            "path": "financeroyaltydetails",
            "navTitle": "报表/提成明细"
          },
          {
            "id": 200106,
            "label": "提成商品",
            "path": "financecommissioncommodity",
            "navTitle": "报表/提成商品"
          },
          {
            "id": 200107,
            "label": "进销概览",
            "path": "financepurchasesalesoverview",
            "navTitle": "报表/进销概览"
          }, {
            "id": 200108,
            "label": "销售分账",
            "path": "xsfz",
            "navTitle": "报表/销售分账"
          }, {
            "id": 200109,
            "label": "分账查询",
            "path": "fzCx",
            "navTitle": "报表/分账查询"
          }
        ]
      }
    ]
  },
  {
    "id": 21,
    "label": "系统",
    "icon": "icon-shezhi2",
    "path": "systemparameter",
    "select": false,
    "data": [{
      "id": 2101,
      "label": "系统",
      "seats": false,
      "children": [{
          "id": 210101,
          "label": "系统参数",
          "path": "systemparameter",
          "navTitle": "系统/系统参数"
        },
        {
          "id": 210102,
          "label": "数据管理",
          "path": "datamanagement",
          "navTitle": "系统/数据管理"
        },
        {
          "id": 210103,
          "label": "操作日志",
          "path": "operationlog",
          "navTitle": "系统/操作日志"
        },
        {
          "id": 210104,
          "label": "登录列表",
          "path": "loginlist",
          "navTitle": "系统/登录列表"
        },
        {
          "id": 210105,
          "label": "关于我们",
          "path": "aboutus",
          "navTitle": "系统/关于我们"
        }
      ]
    }]
  },
  // {
  //   "id": 23,
  //   "label": "价签",
  //   "icon": "icon-shezhi2",
  //   "path": "elabelAdmin",
  //   "select": false,
  //   "data": [{
  //     "id": 2301,
  //     "label": "价签",
  //     "seats": false,
  //     "children": [{
  //       "id": 230101,
  //       "label": "价签管理",
  //       "path": "elabelAdmin",
  //       "navTitle": "价签/价签管理"
  //     }, {
  //       "id": 230102,
  //       "label": "商品管理",
  //       "path": "elabelProAdmin",
  //       "navTitle": "价签/商品管理"
  //     }, ]
  //   }, ]
  // },
  {
    "id": 16,
    "label": "商城",
    "icon": "icon-shangcheng",
    "select": false,
    "path": "scDh",
    "data": [{
        "id": 1600,
        "label": "导航",
        "seats": false,
        "children": [{
          "id": 160001,
          "label": "商城导航",
          "navTitle": "店铺管理/商城导航",
          "path": "scDh"
        }]
      },
      {
        "id": 1601,
        "label": "店铺管理",
        "seats": false,
        "children": [{
          "id": 160101,
          "label": "店铺设置",
          "navTitle": "店铺管理/店铺设置",
          "path": "setupshop"
        }, {
          "id": 160102,
          "label": "页面设计",
          "navTitle": "店铺管理/页面设计",
          "path": "pagedesign"
        }, {
          "id": 160103,
          "label": "线上商品",
          "navTitle": "店铺管理/线上商品",
          "path": "onlinegoods"
        }]
      },
      {
        "id": 1602,
        "label": "订单",
        "seats": false,
        "children": [{
          "id": 160201,
          "label": "订单管理",
          "navTitle": "订单/订单管理",
          "path": "ordermanagement"
        }, {
          "id": 160202,
          "label": "待发订单",
          "navTitle": "订单/待发订单",
          "path": "aftersalesorder"
        }, {
          "id": 160203,
          "label": "商城单据明细",
          "show_label": "单据明细",
          "navTitle": "订单/单据明细",
          "path": "onlineOrderDetail"
        }, {
          "id": 160204,
          "label": "商城商品明细",
          "show_label": "商品明细",
          "navTitle": "订单/商品明细",
          "path": "onlineProDetail"
        }, {
          "id": 160205,
          "label": "商城商品汇总",
          "show_label": "商品汇总",
          "navTitle": "订单/商品汇总",
          "path": "onlineProTotal"
        }]
      },
      {
        "id": 1603,
        "label": "营销",
        "seats": false,
        "children": [{
            "id": 160308,
            "label": "分享有礼",
            "path": "fxYl",
            "navTitle": "营销/分享有礼"
          },{
            "id": 160307,
            "label": "新人优惠",
            "navTitle": "营销/新人优惠",
            "path": "newcomerdiscount"
          },
          {
            "id": 160301,
            "label": "卡券营销",
            "navTitle": "营销/卡券营销",
            "path": "coupon"
          },
          {
            "id": 160303,
            "label": "秒杀设置",
            "navTitle": "营销/秒杀设置",
            "path": "secondkillmanagement"
          },
          {
            "id": 160304,
            "label": "团购设置",
            "navTitle": "营销/团购设置",
            "path": "grouppurchasemanagement"
          },
          {
            "id": 160305,
            "label": "预售设置",
            "navTitle": "营销/预售设置",
            "path": "presalemanagement"
          }

        ]
      }
    ]
  },

  // {

  //   "id": 17,
  //   "label": "加盟",
  //   "icon": "icon-shangcheng",
  //   "select": false,
  //   "path": "jm",
  //   "data": [{
  //       "id": 1701,
  //       "label": "操作",
  //       "seats": false,
  //       "children": [{
  //         "id": 170101,
  //         "label": "申请加盟",
  //         "navTitle": "操作/申请加盟",
  //         "path": "jm"
  //       }, {
  //         "id": 170102,
  //         "label": "下载商品",
  //         "navTitle": "操作/下载商品",
  //         "path": ""
  //       }, {
  //         "id": 170103,
  //         "label": "我要订货",
  //         "navTitle": "操作/我要订货",
  //         "path": ""
  //       }, ]
  //     },
  //     {
  //       "id": 1702,
  //       "label": "订单",
  //       "seats": false,
  //       "children": [{
  //           "id": 170201,
  //           "label": "订单结算",
  //           "navTitle": "订单/订单结算",
  //           "path": ""
  //         },
  //         {
  //           "id": 170202,
  //           "label": "结算明细",
  //           "navTitle": "订单/结算明细",
  //           "path": ""
  //         }
  //       ]
  //     },
  //     {
  //       "id": 1703,
  //       "label": "报表",
  //       "seats": false,
  //       "children": [{
  //         "id": 170301,
  //         "label": "订货单据",
  //         "navTitle": "报表/订货单据",
  //         "path": ""
  //       }, {
  //         "id": 170302,
  //         "label": "订货商品",
  //         "navTitle": "报表/订货商品",
  //         "path": ""
  //       }, {
  //         "id": 170303,
  //         "label": "销售排行",
  //         "navTitle": "报表/销售排行",
  //         "path": ""
  //       }, ]
  //     }
  //   ]

  // },
]

export default {
  nav
}



// WEBPACK FOOTER //
// ./src/assets/StaticResources/menuG.js